import React, { Component } from 'react';
import { FetchOptions } from './FetchOptions';
import { MediaCard } from './MediaCard';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem'
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import { ActionCard } from './MediaCard';

const useStyles = withStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));

export class FetchGroups extends Component {
    static displayName = FetchGroups.name;

    constructor(props) {
        super(props);
        var _props = { ...props };
        if (!_props.currstep) _props.currstep = 0;

        this.state = { data: [], 
            selections: {},
            tagopts: [{ v: 'a', sel: false }, { v: 'b', sel: false }, { v: 'c', sel: false }],
            loading: true
        };
    }

    componentDidMount() {
        if (this.props.root) {
            this.populateData();
        } else {
            this.setState({
                data: this.props.data.configgroup,
                selections: this.props.selections,
                _selections: this.props._selections,
                loading: this.props.root
            });
        }
    }



    renderData(state) {
        
        if (this.props.root) {
            
        } else {
            state = {
                data: this.props.data.configgroup,
                selections: this.props.selections,
                _selections: this.props._selections,
                loading: this.props.root
            };
        }

        let classes = useStyles;

        let currstep = this.props.currstep;
        if (!currstep) {
            //console.log('Initialize');
            currstep = 0;
        }
        let selected = true;

        let _cols = this.props.colstemplate;
        let _temp = this.props.comptemplate;

        if (_temp) {
            _temp = _temp.replace('\r', '').replace('\n', '').replace('/', '').replace('-', '');
        }

        if (_cols) {
            _cols = _cols.replace('\r', '').replace('\n', '').replace('/', '').replace('-', '');
        }

        let state_data = [];

        if (_cols) {
            let eles = _temp.split('{');
            let cole = _cols.split('{');
            eles.forEach((ex, i) => {
                let hex = ex.replace('}', '').replace('-', '').replace('\\', '');
                let hco = cole.length > i ?
                    cole[i].replace('}', '').replace('-', '').replace('\\', '') :
                    "12,1";

                let _ex = state.data.find(x => x.name.trim() == hex.trim());

                if (_ex) {
                    let arhco = hco.split(',');
                    let pcols = arhco[0];
                    let procstep = arhco.length > 1 ? arhco[1] : "1";
                    _ex.pcols = pcols;
                    _ex.procstep = procstep;
                    state_data.push(_ex);
                }
            });



        } else {
            state_data = state.data;
        }

        // sort the data by the procstep, so we can get an accurate
        // currstep
        let tempdata = state_data;
        //let tempdata = [...state_data].sort((x, y) => x.procstep > y.procstep ? 1 : -1);
        tempdata.forEach(dat => {
            let dat_procstep = 0;
            if (dat.procstep) { dat_procstep = dat.procstep; }
            let val = state.selections[this.props.id + '_' + dat.id];

            if (selected) {
                if (dat_procstep > currstep) {
                    currstep = dat_procstep;
                //console.log(currstep);
                }
                if (!val) {
                    selected = false;
                }
            }

        });

        // do a calculation to override the column width if other rows arent ready yet
        // based on the procstep
        state_data.forEach(dat => {
            dat._pcols = dat.pcols;
            let dat_procstep = 0;
            if (dat.procstep) { dat_procstep = dat.procstep; }
            
            if (currstep == dat_procstep) {
                let sum = 0;
                state_data.filter(_dat => {
                    let _dat_procstep = 0;
                    if (_dat.procstep) { _dat_procstep = _dat.procstep; }
                    return currstep >= _dat_procstep;
                }).forEach((a) => {
                    let c = 12;
                    if (a.pcols) { c = parseInt(a.pcols); }
                    sum += c;
                }, 0);

                if (sum % 12 != 0) {
                    //dat._pcols = 12;
                }
            }
        });
        
        // output the groups
        return (
            
            <Grid container spacing={1}>
                
                {state_data.map(dat => {
                    
                    // get the parent column width
                    let dat_pcols = 12;
                    if (dat._pcols) { dat_pcols = dat._pcols; }

                    // get the child column width
                    let ccols = dat.ccols;
                    if (dat.cssclass && this.props.cols) {
                        ccols = this.props.cols;
                    }

                    let val = state.selections[this.props.id + '_' + dat.id];

                    // get the template
                    let temp = this.props.comptemplate;
                    if (!temp) {
                        temp = this.props.template;
                    }

                    // get the title
                    let title = dat.name;
                    if (dat.alttitle) title = dat.alttitle;

                    // make sure the current procstep is greater or equal to the current step
                    // if not set it to hidden
                    let dat_procstep = 0;
                    if (dat.procstep) { dat_procstep = dat.procstep; }
                    if (dat_procstep <= currstep) {
                        // Nothing
                    } else {
                        title = 'HIDE';
                    }

                    // use the selected theme if available, or default to part type cssclass
                    let theme = dat.cssclass ? this.props.theme || dat.cssclass : '';

                    // if the group is in the template and not hidden, display it
                    if (((temp && temp.includes('{' + dat.name + '}')) || dat.maincomp) && title != 'HIDE') {
                        
                        let type = dat.type;
                        
                        let showsch = !val || val == '';
                        return (
                            <React.Fragment key={dat.id}>
                                {dat.title ? <Grid item xs={12}
                                    className={'section-title' + (theme ? ' ' + theme : '')}>
                                    {dat.title}</Grid> : null}
                                <Grid item xs={12} md={parseInt(dat_pcols)}
                                        className={'section-block' + (theme ? ' ' + theme : '')}>
                                    <MediaCard title={this.formatText(title)} type={dat.type}
                                        helpLink={dat.helplink} helpLinkText={dat.helplinktext}
                                        clear={!val || val == '' || val == '?' ? null : () =>
                                            this.props.clear(dat.id, dat.nonevalue && dat.nonevalue!='NA' ? '?' : '')}
                                    infobox={dat.info}
                                    helpInfo={dat.help}
                                    sch={showsch ?
                                        <Grid container justify="flex-start" spacing={1} >

                                            {type == '3' || type == '5' || !dat.searchable ? null :
                                                <React.Fragment>

                                                    <div style={{ display: 'flex', alignItems: 'center' }}>Search:</div>
                                                    <Grid item>
                                                        <TextField
                                                            value={dat.sch}
                                                            onChange={(val) => this.props.schChg(dat.id, val.target.value)}
                                                        />
                                                    </Grid></React.Fragment>}

                                            {!dat.tagopts || dat.tagopts.length == 0 ? null :
                                                <React.Fragment>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>Filters:</div>
                                                    <Grid item>

                                                        <Select
                                                            renderValue={selected => (<span></span>)}
                                                            labelId="units-label"
                                                            label="Units">
                                                            {dat.tagopts.map(value => (
                                                                <MenuItem key={value.v}
                                                                    onClick={(val, v2) => {
                                                                        this.props.tagsChg(dat.id, value.v)
                                                                    }}
                                                                    value={value.v}>{value.v}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Grid>
                                                    <Grid item>

                                                        {dat.tagopts.map(value => {
                                                            if (value.sel) {
                                                                return (
                                                                    <Chip
                                                                        key={value.v}
                                                                        label={value.v}
                                                                        onDelete={() => this.props.tagsDel(dat.id, value.v)}
                                                                    />
                                                                );
                                                            } else {
                                                                return null;
                                                            }
                                                        })}

                                                    </Grid>
                                                </React.Fragment>}
                                        </Grid>
                                        : null}>

                                    {(() => {

                                        let step = 1;
                                        let group_qtyinc = parseFloat(dat.qtyinc);
                                        let group_qtyincoth = parseFloat(dat.qtyincoth);
                                        let group_qtyincpt = parseFloat(dat.qtyincpt);

                                        if (!isNaN(group_qtyinc)) {
                                            if (isNaN(group_qtyincpt) || isNaN(group_qtyincoth) || val <= group_qtyincpt) {
                                                step = group_qtyinc;
                                            }
                                        }
                                        if (!isNaN(group_qtyincpt) && !isNaN(group_qtyincoth)) {
                                            if (val > group_qtyincpt) {
                                                step = group_qtyincoth;
                                            }
                                        }

                                            if (state.selections[this.props.id + '_' + dat.id] != '?' || dat.nonevalue == 'NA') {
                                            if (type == '3') {

                                                if (!state._selections) state._selections = { ...state.selections };

                                                return (
                                                    <TextField
                                                        id="standard-number"
                                                        //label="Number"
                                                        type="number"
                                                        inputProps={{
                                                            step: step.toString(),
                                                            style: { backgroundColor: 'white' }
                                                        }}
                                                        InputLabelProps={{ shrink: true, }}
                                                        value={state._selections[this.props.id + '_' + dat.id]}
                                                        onChange={(val) => this.props.textChange(dat.id, val.target.value)}
                                                        onBlur={(val) => this.props.textBlur(dat.id, val.target.value)}
                                                        style={{ width: '100%' }}
                                                        variant="outlined"
                                                    />
                                                );
                                            } else if (type == '5') {
                                                return (<FetchOptions type={type}
                                                    pc={this.props.pc}
                                                    parts={this.props.parts}
                                                    filt={this.props.filt}
                                                    binding={this.props.binding}
                                                    tags={this.props.tags}
                                                    theme={this.props.theme}
                                                    pcid={this.props.id}
                                                    id={dat.id} data={dat} binding={this.props.binding}
                                                    selections={state.selections} sch={dat.sch} flt={dat.tagopts}
                                                    onClick={(j) => this.props.onClick(dat.id, j)}
                                                    cols={ccols} />);
                                            } else {
                                                return (<FetchOptions
                                                    pc={this.props.pc}
                                                    parts={this.props.parts}
                                                    filt={this.props.filt}
                                                    binding={this.props.binding}
                                                    theme={this.props.theme}
                                                    tags={this.props.tags}
                                                    pcid={this.props.id}
                                                    id={dat.id} data={dat} cssclass={theme}
                                                    selections={state.selections} sch={dat.sch} flt={dat.tagopts}
                                                    onClick={(j) => this.props.onClick(dat.id, j)}
                                                    cols={ccols} />);
                                            }
                                        } else {
                                            return (
                                                <Grid container spacing={1}><Grid item xs={12}>
                                                    <ActionCard
                                                        onClick={() => this.props.clear(dat.id, '')} title={dat.nonevalue}></ActionCard>
                                                </Grid></Grid>
                                            );
                                        }
                                    })()}
                                    </MediaCard>
                                </Grid>
                            </React.Fragment>)
                    }
                    else
                    {
                        // else dont display it
                        return null;
                    }
                })}
            </Grid>
        );
    }

    formatText(txt) {
        if (txt.includes('_')) {
            return txt.replaceAll(' ', '\u00a0').replaceAll('_', ' ');
        } else {
            return txt;
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderData(this.state);

        return (
            <div>
                {contents}
            </div>
        );
    }

    async populateData() {
        const response = await fetch('api/PCProfileImpl/configgroup/'+this.props.id);
        const data = await response.json();
        this.setState({ data, loading: false });
    }
}
